export const EVENT_NAMES = {
    LOGIN_SUCCESS: "login_success",
    LOGOUT: "logout",
    SUPPORT_REQUEST_SUBMIT: "support_request_submit",
    FEEDBACK_REQUEST: "feedback_request",
    RESTORE_PASSWORD: "restore_password",
    CHANGE_PASSWORD: "change_password",
    PAGE_VIEW: "page_view",
    HR_REQUEST_SUBMITTED: "hr_request_submitted",
    LEADER_REQUEST_APPROVED: "leader_request_approved",
    LOCAL_TRIP_CREATED: "local_trip_created",
    LOCAL_TRIP_CANCELLED: "local_trip_cancelled",
    SALARY_REFERENCE_REQUESTED: "salary_reference_requested",
    LAYOFF_REQUEST_CREATED: "layoff_request_created",
    IMPORTANT_TASK_SUBMITTED: "important_task_submitted",
    UNEP_CERTIFICATE_ISSUED: "unep_certificate_issued",
    HR_DOCUMENT_SIGNED: "hr_document_signed",
    PAYROLL_VIEWED: "payroll_viewed",
    UPCOMING_LEAVES_WIDGET_OPENED: "upcoming_leaves_widget_opened",
};
